import React, { useEffect, useState } from 'react'
import PageHeader from '../helper/PageHeader';
import { useHistory } from 'react-router'
//import { authContext } from '../../context/AuthContext';
import Autocomplete from '@mui/material/Autocomplete';
//import { TextValidator } from 'react-material-ui-form-validator';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ListIcon from '@mui/icons-material/ViewList';
import PeopleIcon from '@mui/icons-material/People';
import Grid from '@mui/material/Grid';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

import axios from 'axios';

const AdminTrainingProvider = (props) => {
    const history = useHistory()   
    // const params = useParams()
    // const context = useContext(authContext)

    const [data, setData] = useState(null);

    const [trainingProviders, setTrainingProviders] = useState([]);
    const [trainingProvider, setTrainingProvider] = useState(null);

    const [username, setUserName] = useState(null);

    async function getTrainingProviderData(tpID) {
        const res = await axios.all([
            axios.get('/api/usergroup/'+ tpID, {}),
            axios.get('/api/credit/log/'+ tpID, {})
        ])
    
        console.log('res', res);
        setData(res[1].data);
    }

    useEffect(() => {
        if (trainingProvider)
            getTrainingProviderData(trainingProvider.id);

    }, [trainingProvider])

    async function getTrainingProviders() {
        const res = await axios.get('/api/usergroup/list/trainingProvider', {
        });

        console.log('res trainingProvider', res);
        let trainingProviders = [];

        let resultData = res.data.providers

        if (resultData.length > 0) {
            resultData.map((u) =>
                trainingProviders.push({ id: u.id, name: u.name, })
            )
        };
        setTrainingProviders(trainingProviders);
        let selectedEmployer = JSON.parse(sessionStorage.getItem('adminSelectedTP'));
        console.log(selectedEmployer);
        if (selectedEmployer) {
            console.log(selectedEmployer.id)
            setTrainingProvider({id:selectedEmployer.id, name: selectedEmployer.name} );
        }
    }

    useEffect(() => {

        getTrainingProviders();

    },[])

    const onTrainingProviderSelect = (name, value) => {

        let selected = value;

        if (selected === null) {
           
            setTrainingProvider(null)
            sessionStorage.removeItem('adminSelectedTP')
            setData(null)
            getTrainingProviders();
            return;
        }
        setTrainingProvider({id:selected.id, name: selected.name} );
        sessionStorage.setItem('adminSelectedTP', JSON.stringify(selected))

        getTrainingProviderData(selected.id);
    }
  
    const onEditDefault = () => {
        history.push('/administration/trainingProviders/edit/'+ trainingProvider.id);
        
    }

    const TrainingProviderAdminClicked = () => {
        console.log('trainingProvider admin ');
        history.push('/administration/trainingProviders/members/'+ trainingProvider.id);
        
    }

    const onManageClasses = event => {
        history.push('/administration/trainingProviders/manageClasses/' + trainingProvider.id);        
    }


    const onChange = (e) => {
        setUserName(e.target.value)
        console.log('target value', e.target.value)
    }

    const onSearchUser = async () => {
        console.log('search clikced username', username)
        const res = await axios.get(' /api/groupUser/group/' + username, {
        });

        console.log('res', res)

        let rest = res.data.groups
        let trainingProviders = [] 

        let filteredRest = rest.filter( data => data.type=== "Training Provider" )

        console.log('filtered Rest', filteredRest)

        rest = filteredRest

        if (rest.length > 0) {
            rest.map((u) =>
                trainingProviders.push({ id: u.id, name: u.name, })
            )
        };
        console.log('new trainingProvider', trainingProviders)
        setTrainingProviders(trainingProviders);
        setTrainingProvider(null)
    }

    const onClear = () => {
        setUserName(null)
        setTrainingProvider(null)
        sessionStorage.removeItem('adminSelectedTP')
        setData(null)
        getTrainingProviders();
    }

    return <>
        <PageHeader title={"Manage Training Providers" }
            cancel={history.goBack} 
        />
            <Grid container spacing={3}>
                <Grid item xs={12}  md={4}>
                        <TextField
                            id="username"
                            label="(Optional) Enter a Username"
                            type="text"
                            className={[].join(' ')}
                            value={username || "" }
                            onChange = {onChange}
                            name='username'
                            fullWidth
                        />
                </Grid>
                <Grid item xs={12}  md={4} style={{ textAlign: "center", alignSelf: "flex-end", margin: 10 }}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    className={[].join(' ')} 
                    onClick={ onSearchUser}
                >
                    Filter Training Provider List
                    </Button>
                </Grid>
                <Grid item xs={10}  md={1} style={{ textAlign: "center", alignSelf: "flex-end",   margin: 10 }}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    className={[].join(' ')} 
                    onClick={ onClear }
                >
                    Clear
                    </Button>
                </Grid>
            </Grid>
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            <Grid item xs={12}  md={4}>
                <Autocomplete
                    id="trainingProviders"
                    options={trainingProviders}
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) => option.id === "" || value.id}
                    onChange={onTrainingProviderSelect}
                    value={trainingProvider || null}
                    className={'class-admin-trainingProviders'}
                    renderInput={(params) => <TextField {...params} label="Select Training Provider" />}
                    disabled={trainingProviders.length === 0}
                />
          </Grid>
        </Grid>
      
        {data === null ?  <h1>Please select a Training Provider</h1>  :
            <>
                <Grid container direction="row" justifyContent="space-around" alignItems="center" style={{ marginTop: 10 }}>
                 <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={TrainingProviderAdminClicked}
                    startIcon={<PeopleIcon />}
                >
                    Training Provider Admin
                </Button>
                 <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={onEditDefault}
                    startIcon={<ListIcon />}
                >
                    Edit Defaults
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={onManageClasses}
                    startIcon={<FormatListBulletedIcon />}
                >
                    Manage Classes
                </Button>
                    
                </Grid>
                
            </>
        }

    </>;
}

export default AdminTrainingProvider